/**
 * 导航组件
 */
import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import FetchData from '@ezviz/FetchData';
// import {
//   Link, NavLink
// } from 'react-router-dom';
// import Link from 'next/link';
import './indexStyle.less';
import { Popover } from 'antd';
import NewPop from '../newPop';
import NavSearch from '../navSearch';
import NewPopWithoutTabs from '../newPopWithoutTabs';
import NewPopSolution from '../NewPopSolution';
import NewPopAi from '../NewPopAi';
import { Badge, Avatar, Icon, message } from '@ezviz/ezd';
import * as OpenFetch from '@ezviz/OpenFetch';
import moment from 'moment'
import { useHandleScroll } from './utils'

import crypto from 'crypto';

function getSHA256(text) {
  return crypto.createHash('sha256').update(text).digest('hex');
}


const iotDomain = 'iot.eziot.com';

const goPreVision = (version) => {
  if (version == 'pre') {
    Cookies.set('web-version', 'pre', { path: '/' });
  } else {
    Cookies.set('web-version', '', { path: '/' });
  }
}

function NavMainLink(props) {
  if (props.href) {
    // 兼容旧站
    // 新版控制台

    if (props.href === '/consoleCN/home.html') {
      return (<span
        style={{ padding: '19px 12.5px' }}
        className={(!props.scrollStatus && props.headerType == 1) ? "Nav-NavMainLink nav-banner-type" : 'Nav-NavMainLink'}
        onClick={() => {
          window.open(props.href);
          window.monitor && window.monitor.report({ textKey: 'website_nav_tab_item', text: props.title || '' });
        }}
      ><span className={(!props.scrollStatus && props.headerType == 1) ? "" : "Nav-NavMainLink"} style={{ color: (!props.scrollStatus && props.headerType == 1) ? '#ffffff' : '#262626' }}>{props.title}</span></span>);
    }
    if (props.href.startsWith('http')) {
      return <a
        style={{ padding: '19px 12.5px' }}
        onClick={() => {
          window.monitor && window.monitor.report({ textKey: 'website_nav_tab_item', text: props.title || '' });
        }}
        className={(!props.scrollStatus && props.headerType == 1) ? "Nav-NavMainLink nav-banner-type" : 'Nav-NavMainLink'}
        target={props.target || '_self'} href={props.href} >
        <span className={(!props.scrollStatus && props.headerType == 1) ? "" : "Nav-NavMainLink"}
          style={{ color: (!props.scrollStatus && props.headerType == 1) ? '#ffffff' : '#262626' }}>
          { props.titleIcon && <img className="nav-icon-img" src={props.titleIcon} />}
          <span className="nav-icon-label">{props.title}</span>
          {props.data && props.data.length > 0 && <i className="nav-icon-wrap"><span className="nav-icon-up"><Icon type="up" /></span><span className="nav-icon-up"><Icon type="down" /></span></i>}
        </span>
      </a>;
    }
    return <span style={{ padding: '19px 12.5px' }}
      className={(!props.scrollStatus && props.headerType == 1) ? "Nav-NavMainLink nav-banner-type" : 'Nav-NavMainLink'}>
      <a onClick={() => {
        window.monitor && window.monitor.report({ textKey: 'website_nav_tab_item', text: props.title || '' });
      }} href={props.href} activeClassName="selected" className="Nav-NavMainLink" >
        <span className={(!props.scrollStatus && props.headerType == 1) ? "" : "Nav-NavMainLink"} style={{ color: (!props.scrollStatus && props.headerType == 1) ? '#ffffff' : '#262626' }}>
          { props.titleIcon && <img className="nav-icon-img" src={props.titleIcon} />}
          <span className="nav-icon-label">{props.title}</span>
          {props.data && props.data.length > 0 && <i className="nav-icon-wrap"><span className="nav-icon-up"><Icon type="up" /></span><span className="nav-icon-down"><Icon type="down" /></span></i>}
        </span>
      </a>
    </span>;
  } else {
    return <span style={{ padding: '19px 12.5px' }} className={(!props.scrollStatus && props.headerType == 1) ? "Nav-NavMainLink nav-banner-type" : 'Nav-NavMainLink'}>
      <span onClick={() => {
        window.monitor && window.monitor.report({ textKey: 'website_nav_tab_item', text: props.title || '' });
      }} className={(!props.scrollStatus && props.headerType == 1) ? "" : "Nav-NavMainLink"} style={{ color: (!props.scrollStatus && props.headerType == 1) ? '#ffffff' : '#262626' }}>
        { props.titleIcon && <img className="nav-icon-img" src={props.titleIcon} />}
        <span className="nav-icon-label">{props.title}</span>
        {props.data && props.data.length > 0 && <i className="nav-icon-wrap"><Icon className="nav-icon-up" type="up" /><Icon className="nav-icon-down" type="down" /></i>}
      </span>
    </span>
  }
}

function MyLink(props) {
  if (props.href) {
    return <span className="Nav-NavMainLink"><span className="Nav-link"><a href={props.href} activeClassName="selected" className="Nav-link" >{props.title}</a>{props.isNew && <span className="hotTip">new</span>}</span></span>;
  } else {
    return <span className="Nav-link noLink">{props.title}{props.isNew && <span className="hotTip">new</span>}</span>
  }
}

function NavSubItems(props) {
  const subs = props.data.map(item => {
    // 判断有没有tag标签，有的话则另起一行

    let subItems = null;
    if (item.data && item.data.length > 0) {
      // 子项按照tag分类
      const category = [[]];
      let idx = 0;
      item.data.forEach(i => {
        if (i.tag) {
          idx++;
          category.push([]);
          category[idx].push(i);
        } else {
          category[idx].push(i);
        }
      })
      subItems = category.map(array => {
        return <div className="Nav-items-container">
          {array.map(i => {
            if (i.tag) {
              return <div className="Nav-tag-container" >
                <div className="Nav-tag-text">{i.tag}</div>
                <span><MyLink href={i.href} title={i.title} isNew={i.isNew || null} /></span>
              </div>
            }
            return <span><MyLink href={i.href} title={i.title} isNew={i.isNew || null} /></span>
          })}
        </div>
      })

    }
    return <div className="Nav-subItem-container">
      <span className="Nav-SubItem-link-title">
        <MyLink href={item.href} title={item.title} isNew={item.isNew || null} />
      </span>
      <div className="Nav-SubItem-link-container">
        {subItems}
      </div>
    </div>
  });
  return <div>
    {subs}
  </div>
}

// 选择类型展示
function NavSelectItems(props) {
  const subs = props.data.map(item => {
    if (item.href.startsWith('http')) {
      return <div className="Nav-SelectLink">
        <a className="Nav-SelectLink Nav-SelectLink-href" target={item.target || '_self'} href={item.href}>{item.title}</a>
      </div>;
    }
    return <div className="Nav-SelectLink">
      <a className="Nav-SelectLink Nav-SelectLink-href" href={item.href} activeClassName="selected">{item.title}</a>
    </div>

  });
  return <div>
    {subs}
  </div>
}
// 导航项最少为6项
const MIN_ITEM_LENGTH = 6;

function scrollTypeCheck() {
  let scrollType = ''
  const NavItemsContianerDom = document.getElementsByClassName('Nav-items-contianer')[0];
  const commonMenuScrollBarDom = document.getElementsByClassName('common-menu-scroll-bar')[0];
  const NavItemsContianerMarginLeft = parseInt(NavItemsContianerDom.style.marginLeft) || 0;
  const commonMenuScrollBarWidth = parseInt(commonMenuScrollBarDom.clientWidth) || 0;
  const NavItemsContianerWidth = parseInt(NavItemsContianerDom.scrollWidth) || 0;
  console.log('NavItemsContianerWidth', NavItemsContianerWidth)
  console.log('NavItemsContianerMarginLeft', NavItemsContianerMarginLeft)
  console.log('commonMenuScrollBarWidth', commonMenuScrollBarWidth)

  if (NavItemsContianerWidth > commonMenuScrollBarWidth) {
    if (NavItemsContianerMarginLeft >= 0) { // 说明是在最左边
      scrollType = 'scrollRight'
    } else {
      if (NavItemsContianerWidth + NavItemsContianerMarginLeft <= commonMenuScrollBarWidth) { // 说明是在最右边  
        scrollType = 'scrollLeft'
      } else {
        scrollType = 'scrollAll'
      }
    }
  } else {
    scrollType = ''
  }
  console.log('scrollType', scrollType)
  return scrollType;
}

const Nav = (props) => {

  
  const [loaded, setLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [scrollStatus, setScrollStatus] = useState(false);
  const [navClassName, setNavClassName] = useState(`Nav ${props.theme}`)
  const [logoUrl, setLogoUrl] = useState(`${props.logo}`)
  const [scrollType, setScrollType] = useState('')
  const [workNum, setWorkNum] = useState(0)
  const [isLogin, setIsLogin] = useState(false)
  const [dot, setDot] = useState(false)

  // 导航滚动进行状态
  const [scrolling, setScrolling] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)

  const [isScroll, handleScroll, getBeginnerNavigator] = useHandleScroll(props.ignoreList, setTabIndex)

  const username = Cookies.get('ASG_DisplayName');

  const isSafari = () => {
    let userAgent = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(userAgent);
  }
  useEffect(() => {
    const username = Cookies.get('ASG_DisplayName');
    let isLogin = username && username.length > 0;
    const logoutStatus = localStorage.getItem('logoutStatus')
    console.log('logoutStatus:', logoutStatus)
    if (isSafari() && logoutStatus === 'true') { // 兼容safari读取缓存cookies的问题
      isLogin = false
    }
    setIsLogin(isLogin)
    if (isLogin) {
      const fetchData = new FetchData('/web/console/workList/count', {
        method: 'GET',
        headers: {
          csrftoken: Cookies.get('csrftoken')
        },
        body: {}
      });
      fetchData.then((data) => {
        if (data.meta && data.meta.code === 200) {
          const { waitConfirmCount, waitSupplementaryCount } = data.data;
          setWorkNum(waitConfirmCount + waitSupplementaryCount);
        }
      }).catch((err) => { });
    }
  }, []);
  // 这个副作用是为了调用退出IOT控制台的图片链接
  useEffect(() => {
    const username = Cookies.get('ASG_DisplayName');
    let isLogin = username && username.length > 0;
    const logoutStatus = localStorage.getItem('logoutStatus')
    if (isSafari() && logoutStatus === 'true') { // 兼容safari读取缓存cookies的问题
      isLogin = false
    }
    if (!isLogin) {
      const iotLogout = Cookies.get('iotLogout');
      if (iotLogout && iotLogout == '1') {
        var image = document.createElement('img');
        image.src = `http://${iotDomain}/logout?_r=${Math.random()}`;
        Cookies.set('iotLogout', '0', { expires: 365, path: '/' });
      }
    } else {
      Cookies.set('iotLogout', '0', { expires: 365, path: '/' });
    }
    setLoaded(true);
    const scrollType = scrollTypeCheck();
    setScrollType(scrollType);
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", addScroll);
    window.addEventListener("resize", () => {
      const scrollType = scrollTypeCheck();
      setScrollType(scrollType);
    });
    getNewProduct()
    return () => {
      window.removeEventListener("scroll",addScroll);
    }
  }, []);

  const getArticleSign = (obj) => {
    let sign = "";
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key].forEach((i, index) => {
          sign += `&${key}%5B${index}%5D=${encodeURIComponent(i)}`;
        });
      } else {
        sign += `&${key}=${encodeURIComponent(obj[key])}`;
      }
    }

    let key = '14c34a0dfbee32363d32becb857b30a5347797a2f885b44eacca1e6c6fab274f';

    if (window.location.host.indexOf('test') !== -1) {
        key = '123456';
    } 
    sign = sign.slice(1) + key;

    sign = getSHA256(sign);

    return sign;
  }
  const getNewProduct = () => {
    const requestObj = {
      category: ["公告"],
      pageNum: 1,
      pageSize: 1,
    };
    const sign = getArticleSign(requestObj)


    let DOMAIN = 'https://club.ys7.com';

    if (window.location.host.indexOf('test') !== -1) {
      DOMAIN = 'https://test-bbs.ezv-test.com';
    } 

    fetch(`${DOMAIN}/interface/articleList.php`, {
      method: "post",
      body: JSON.stringify(requestObj),
      headers: { sign, "Content-Type": "application/json" },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {

        if (data.data) {
          let item = data.data[0];
          const tag = moment(item.dateline).diff(moment(), "day") > -20
          setDot(tag);
        } else {
          setDot(false);
        }
      })
      .catch((err) => {
        setDot(false);
      });
  }
  // 兼容auth中间件里登录超级账号会有日志上报逻辑
  const saveOperateLogApi = () => {
    // 成功回调
    const success = (data) => {
      console.log('日志上传:', data)
    };
    // 失败回调
    const error = (data) => {
      console.log('日志上传失败')
    };
    const url = '/console/developer/saveOperateLog'
    var requestOptions = {
      operateType: '超级账号注销',
      operateStatusBefore: '已登录',
      operateStatusAfter: '注销成功'
    };
    const fetchData = new OpenFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: { ...requestOptions },
    });
    fetchData.then((data) => {
      success(data)
    }).catch(e => {
      console.log(e)
      error(e)
    })
  }

  const setUrlParam = (key, value) => {
    let params = new URLSearchParams(window.location.search);
    params.delete("searchTxt")
    params.set(key, value);
    window.location.search = params.toString();
  }

  const checkout = () => {
    // window.location.href = `/logout?host=${window.location.host}&returnUrl=index&r=${Math.random()}`;
    let callback = () => {
      localStorage.removeItem('accessToken');
      // 标记退出IOT控制台
      Cookies.set('iotLogout', '1', { expires: 365, path: '/' });
      postMessageLogoutChange()
      //记录超级账号类型用户登出
      if (/^sys_.*$/.test(username)) {
        saveOperateLogApi()
      }
      if (!!username) {
        Cookies.remove('ASG_DisplayName')
      }
      localStorage.setItem('logoutStatus', 'true')
      let rData = new Date().getTime() + Math.random(10)
      setUrlParam('r', rData);
      // window.location.reload()
      // window.location.href = `/console/login.html?host=${window.location.host}&returnUrl=index&r=${Math.random()}`;
    }
    checkoutApi(callback)
  }
  // 用户退出通知
  const postMessageLogoutChange = () => {
    // 是否为移动端
    const isMobile = !!navigator.userAgent.match(/(iPhone|iPod|iPad|Android|ios|SymbianOS)/i);
    if (!isMobile && 'BroadcastChannel' in window) {
      const setChannel = new BroadcastChannel('ezviz_login');
      setChannel.postMessage('logout,' + window.location.pathname);
    }
  }
  const checkoutApi = (callback = () => { }) => {
    let url = '/console/login/exit'
    const fetchData = new OpenFetch(url, {
      method: 'GET',
    });
    fetchData.then((data) => {
      if (!!data.meta && data.meta.code == 200) {
        callback()
      } else {
        message.error('退出失败，请重试')
      }
    }).catch(e => {
      message.error('退出失败，请重试')
    })
  }

  const addScroll = () => {
    let innerWidth = window.innerWidth || 0;
    if (document.documentElement.scrollTop > 0 && innerWidth > 1270) {
      setNavClassName('Nav bright');
      if (props.logo === 'https://resource.eziot.com/group2/M00/00/88/CtwQFmLQFbWAWAfTAAAPQ2UCiLw942.png') {
        setLogoUrl('https://resource.eziot.com/group2/M00/00/70/CtwQF2HOYHaAV_GpAAAOaWjKNFo202.png')
      }
      setScrollStatus(true)
    } else {
      setNavClassName(`Nav ${props.theme}`);
      setLogoUrl(`${props.logo}`)
      setScrollStatus(false)
    }
  };

  const menuScroll = (type) => {
    const NavItemsContianerDom = document.getElementsByClassName('Nav-items-contianer')[0];
    const commonMenuScrollBarDom = document.getElementsByClassName('common-menu-scroll-bar')[0];
    const NavItemsContianerMarginLeft = parseInt(NavItemsContianerDom.style.marginLeft) || 0;
    const commonMenuScrollBarWidth = parseInt(commonMenuScrollBarDom.clientWidth) || 0;
    if (type == 'left') {
      let marginLeft = NavItemsContianerMarginLeft + commonMenuScrollBarWidth;
      marginLeft = marginLeft > 0 ? 0 : marginLeft;
      NavItemsContianerDom.style.marginLeft = `${marginLeft}px`
    }
    if (type == 'right') {
      NavItemsContianerDom.style.marginLeft = `${NavItemsContianerMarginLeft - commonMenuScrollBarWidth}px`
    }

    // 导航滚动动画时间500ms完成后再判断滚动条状态
    setTimeout(() => {
      const scrollType = scrollTypeCheck();
      setScrollType(scrollType);
      setScrolling(false)
    }, 550)
  }

  let moduleStyle = {};
  if (props.style) {
    moduleStyle = Object.assign({}, props.style);
  }

  const { data, headerType = 0, linkNavTitle, querySelectorAll = "", anchorPointList = [] } = props;

  let res = useRef([])

  useEffect(() => {
    let tag = anchorPointList.includes(window.location.pathname)
    if (tag) {
      res.current = getBeginnerNavigator(querySelectorAll)
      window.addEventListener("scroll", handleScroll)
    }
    return () => {
      tag && window.removeEventListener("scroll", handleScroll)
    }
  }, [])


  return <div id='openweb-nav' style={moduleStyle} className={`${navClassName} white ${props.headerType == 1 ? 'navType' : ''}`}>
    {isScroll && <div className="Nav-container">
      <div className="Nav-logo">
        <a textkey="website_nav_logo" href={"/cn"} className="logo-bak"><img src={'https://resource.eziot.com/group2/M00/00/70/CtwQF2HOYHaAV_GpAAAOaWjKNFo202.png'} alt="logo" /></a>
        <a textkey="website_nav_logo" href={"/cn"}><img src={(!scrollStatus && props.headerType == 1) ? 'https://resource.eziot.com/group2/M00/00/88/CtwQFmLQFbWAWAfTAAAPQ2UCiLw942.png' : logoUrl} alt="logo" /></a>
      </div>
      <div className={`common-menu-inner ${scrollType}`}>
        <div className='scroll-left-arrow' onClick={() => {
          if (!scrolling) {
            menuScroll('left')
            setScrolling(true)
          }
        }}></div>
        <div className="common-menu-scroll-bar">
          <div className="Nav-items-contianer">
            {data.map((item, index) => {
              if (!item) {
                return <span key={index} className="Nav-NavMainLink"></span>
              }
              if ((item.data && item.data.length > 0) || item.type == 'newMessage') {
                if (item.type && (item.type == 'select' || item.type == 'search' || item.type == 'newMessage')) {
                  return null
                }
                if (item.type && item.type == 'newPop') {
                  return <Popover
                    getPopupContainer={triggerNode => {
                      if (triggerNode && triggerNode.children && triggerNode.children.length > 0) {
                        return triggerNode.children[0];
                      }
                      return triggerNode;
                    }
                    }
                    key={index} overlayClassName="Nav-popover-newPop" content={<NewPop style={{ background: 'white' }} {...item} />} trigger="hover" placement="bottom">

                    <span><NavMainLink scrollStatus={scrollStatus} headerType={headerType} {...item} /></span>
                  </Popover>
                }
                if (item.type && item.type == 'newPop2') {

                  return <Popover
                    getPopupContainer={triggerNode => {
                      if (triggerNode && triggerNode.children && triggerNode.children.length > 0) {
                        return triggerNode.children[0];
                      }
                      return triggerNode;
                    }
                    }
                    key={index} overlayClassName="Nav-popover-newPop2" content={<NewPopWithoutTabs style={{ background: 'white' }} {...item} />} trigger="hover" placement="bottom">

                    <span><NavMainLink scrollStatus={scrollStatus} headerType={headerType} {...item} /></span>
                  </Popover>
                }
                if (item.type && item.type == 'newPop3') {

                  return <Popover
                    getPopupContainer={triggerNode => {
                      if (triggerNode && triggerNode.children && triggerNode.children.length > 0) {
                        return triggerNode.children[0];
                      }
                      return triggerNode;
                    }
                    }
                    key={index} overlayClassName="Nav-popover-newPop" content={<NewPopSolution style={{ background: 'white' }} {...item} />} trigger="hover" placement="bottom">

                    <span><NavMainLink scrollStatus={scrollStatus} headerType={headerType} {...item} /></span>
                  </Popover>
                }
                if (item.type && item.type == 'newPop4') {

                  return <Popover
                    getPopupContainer={triggerNode => {
                      if (triggerNode && triggerNode.children && triggerNode.children.length > 0) {
                        return triggerNode.children[0];
                      }
                      return triggerNode;
                    }
                    }
                    key={index} overlayClassName="Nav-popover-newPop" content={<NewPopAi style={{ background: 'white' }} {...item} />} trigger="hover" placement="bottom">

                    <span><NavMainLink scrollStatus={scrollStatus} headerType={headerType} {...item} /></span>
                  </Popover>
                }
                return <Popover
                  getPopupContainer={triggerNode => {
                    if (triggerNode && triggerNode.children && triggerNode.children.length > 0) {
                      return triggerNode.children[0];
                    }
                    return triggerNode;
                  }
                  }
                  key={index} overlayClassName="Nav-popover" content={<NavSubItems {...item} />} trigger="hover" placement="bottom">

                  <span><NavMainLink scrollStatus={scrollStatus} headerType={headerType} {...item} /></span>
                </Popover>
              } else {
                if (item.href === '/consoleCN/home.html' && !isLogin) {
                  return <a key={index} className="Nav-NavMainLink" style={{ color: headerType == 1 ? '#ffffff' : '#262626' }}
                    onClick={() => {
                      window.location.href = `/auth?host=${window.location.host}&r=${Math.random()}&returnUrl=${window.location.protocol}//${window.location.host}/consoleCN/home.html`;
                    }}
                  >{item.title}</a>
                }
                return <NavMainLink scrollStatus={scrollStatus} headerType={headerType} linkNavTitle={linkNavTitle} key={index} {...item} />
              }
            })}
          </div>
        </div>
        <div className='scroll-right-arrow' onClick={() => {
          if (!scrolling) {
            menuScroll('right')
            setScrolling(true)
          }
        }
        }></div>
      </div>

      <div className="login-container">

        {
          data.map((item, index) => {
            if ((item.data && item.data.length > 0) || item.type == 'newMessage') {
              if (item.type && item.type == 'search') {
                return <NavSearch data={item.data} placeholder={item.placeholder} />
              }
              if (item.type && item.type == 'newMessage') {
                return <div className={dot ? "login-item red-dot" : "login-item"}>
                  <span className='login-item-console' style={{ color: (!scrollStatus && props.headerType == 1) ? '#ffffff' : '' }} onClick={() => {
                    window.open('https://club.ys7.com/portal.php?mod=list&catid=64', "_blank");
                    window.monitor && window.monitor.report({ textKey: 'website_nav_new_message', text: '控制台' });
                  }}>最新消息</span>
                </div>
              }
              if (item.type && item.type == 'select') {
                return <Popover
                  getPopupContainer={triggerNode => {
                    if (triggerNode && triggerNode.children && triggerNode.children.length > 0) {
                      return triggerNode.children[0];
                    }
                    return triggerNode;
                  }
                  }
                  key={index} onVisibleChange={(visible) => setVisible(visible)} overlayClassName="Nav-popover2" content={<NavSelectItems {...item} />} trigger="hover" placement="bottom">
                  <div onClick={() => {
                    window.monitor && window.monitor.report({ textKey: 'website_nav_tab_country', text: item.title || '' });
                  }} className={(!scrollStatus && props.headerType == 1) ? "login-item nav-banner-login" : "login-item"}>{item.title} {visible ? <Icon type="up" /> : <Icon type="down" />}</div>
                </Popover>
              }
            }
          })
        }
        <div className={(!scrollStatus && props.headerType == 1) ? "login-item nav-banner-login" : "login-item"}>
          <span className='login-item-console' style={{ color: (!scrollStatus && props.headerType == 1) ? '#ffffff' : '' }} onClick={() => {
            window.location.href = "/console/home.html";
            window.monitor && window.monitor.report({ textKey: 'website_nav_console', text: '控制台' });
          }}>控制台</span>
        </div>
        {(loaded && isLogin) ?
          <span>
            <div className={`login-item userinfo-wrap ${(!scrollStatus && props.headerType == 1) ? 'login-item nav-banner-login' : ''}`}>
              <Badge size="small" count={workNum} overflowCount={10}>
                <span className='user-icon'></span>
              </Badge>
              <div className="nav-userinfo-username-label">{username}</div>
              <div className="nav-userinfo-menu">
                <div className="menuUrl">
                  <span className="nav-userinfo-username">{username}</span>
                  <a href="/console/account.html" className="row titleItem" textkey="website_nav_user_info">
                    <div className='titleItem-left'>
                      <span className='titleItem-icon user' />
                      <div className="titleItemTxt">账号信息</div>
                    </div>
                  </a>
                  <a href="/console/application.html" className="row titleItem" textkey="website_nav_user_app">
                    <div className='titleItem-left'>
                      <span className='titleItem-icon application' />
                      <div className="titleItemTxt">应用信息</div>
                    </div>
                  </a>
                  <a href="/console/workList.html" className="row titleItem" textkey="website_nav_user_work">
                    <div className='titleItem-left'>
                      <span className='titleItem-icon workorder' />
                      <div className="titleItemTxt">工单中心</div>
                    </div>
                    {workNum > 0 && <span className="workorder-num">待处理{workNum > 10 ? '10+' : workNum}</span>}
                  </a>
                  <a href="/console/consumeDaily.html" className="row titleItem" textkey="website_nav_user_consume">
                    <div className='titleItem-left'>
                      <span className='titleItem-icon cost' />
                      <div className="titleItemTxt">费用中心</div>
                    </div>
                  </a>
                </div>
                <div className="titleBottonBox">
                  {/* <div onClick={() => {
                    const logoutUrl = '/logout?host=' + window.location.host + '&returnUrl=index&r=' + Math.random();
                    localStorage.removeItem('accessToken');
                    location.href = logoutUrl;
                    // 标记退出IOT控制台
                    Cookies.set('iotLogout', '1', { expires: 365, path: '/' });
                  }} className="titleBotton" textkey="website_nav_user_logout">退出登录</div> */}
                  <div onClick={checkout} className="titleBotton" textkey="website_nav_user_logout">退出登录</div>
                </div>
              </div>
            </div>
          </span>
          :
          <span>
            <div className={(!scrollStatus && props.headerType == 1) ? "login-item nav-banner-login" : "login-item"} onClick={() => {
              const loginUrl = `/auth?host=${window.location.host}&r=${Math.random()}&returnUrl=${window.location.href}`;
              window.location.href = loginUrl;
              window.monitor && window.monitor.report({ textKey: 'website_nav_login', text: '登录' });
            }}>登录</div>
            <span className="login-divider"></span>
            <div className={"login-item login-item-register"}><a textkey="website_nav_register" href="/view/register/register.html" style={{ color: (!scrollStatus && props.headerType == 1) ? '#ffffff' : '' }}>立即注册</a></div>
          </span>
        }
      </div>
    </div>}
    {!isScroll &&
      <div className='BeginnerNavigator'>
        <div id='BeginnerNavigator-container' className="BeginnerNavigator-container adaptive">
          <div className="BeginnerNavigator-container-content row">
            {
              res.current.map((item, index) => {
                return <div
                  key={"nav-search" + index}
                  onClick={() => {
                    let domTarget = document.getElementById(item.id || '')
                    let topTmp = item.AnchorTop || 100
                    if (domTarget) {
                      let topSize = domTarget.offsetTop - topTmp
                      document.documentElement.scrollTo(0, topSize)
                    }
                    window.monitor && window.monitor.report({ textKey: 'website_beginnernavigator_item', text: item.title || '' });
                  }}
                  className={tabIndex == index ? 'container-content-item container-content-item-checked' : 'container-content-item'}
                >{item.text}</div>

              })
            }
          </div>
        </div>
      </div>
    }
  </div>



}

export default Nav;
